module.exports = __webpack_public_path__ + "static/media/up.a067bec7.svg";